export default {
    path: 'blog-collection',
    component: () => import('../BlogCollection.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách Nhóm bài viết',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo Nhóm bài viết',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa Nhóm bài viết',
            component: () => import('../cu/CU.vue'),
        },
    ]
};